import { getTableShowingRange } from "components/table";
import { useCallback, useEffect, useMemo, useState } from "react";

// Phân trang tại trình duyệt cho bảng đã tải đủ dữ liệu — dùng chung chân bảng "Hiển thị x đến y trong tổng z dòng"
export const useClientPaging = <T,>(rows: T[], defaultLimit = 50) => {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(defaultLimit);

  useEffect(() => {
    setPage(1);
  }, [rows]);

  const pageRows = useMemo(() => rows.slice((page - 1) * limit, page * limit), [rows, page, limit]);

  const onChange = useCallback(({ page: nextPage, limit: nextLimit }: { page: number; limit: number }) => {
    setPage(nextPage);
    setLimit(nextLimit);
  }, []);

  const { showingFrom, showingTo } = getTableShowingRange(page, limit, rows.length);

  return { pageRows, page, limit, total: rows.length, showingFrom, showingTo, onChange };
};
